// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"8fdc76b5","551":"0804bdca","637":"5f2d12ac","707":"452a66a3","851":"2467b83f"}[chunkId] + ".chunk.js";
};